import { faEdit, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Modal, Row, Table } from "@themesberg/react-bootstrap";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import ToastPopup from "../common/ToastPopup";
import { PropertyContext } from "../contexts/PropertyContext";

const TagLineInput = ({
	editData,
	setEditIndex,
	getAllTagsFromContext,
	createNewTagFromContext,
	updateTagFromContext,
}) => {
	const [tagInput, setTagInput] = useState("");

	const handleInputChange = (e) => {
		setTagInput(e.target.value);
	};

	const handleSubmitButton = () => {
		if (tagInput?.length > 0 && tagInput?.length <= 20) {
			if (editData) {
				updateTagFromContext(editData?.id, { name: tagInput }, () => {
					getAllTagsFromContext(() => {
						setEditIndex(-1);
					});
				});
			} else {
				createNewTagFromContext({ name: tagInput }, () => {
					getAllTagsFromContext();
				});
			}
		} else {
			ToastPopup("error", "Tag length must be between 0 to 20!");
		}
	};

	useEffect(() => {
		if (editData) {
			setTagInput(editData?.name);
		}
	}, [editData]);

	return (
		<Row>
			<Col></Col>
			<Col md={6} className="mb-3">
				<Form.Group id="add-tag-input">
					<Form.Control
						required
						type="text"
						name="add_tag"
						value={tagInput}
						onChange={(e) => handleInputChange(e)}
						onFocus={() => !editData && setEditIndex(-1)}
						placeholder="Enter New Tag"
					/>
				</Form.Group>
			</Col>
			<Col md={2} className="mb-3">
				<Button variant="dark" onClick={() => handleSubmitButton()}>
					Submit
				</Button>

				{editData && (
					<Button className="mx-2" variant="danger" onClick={() => setEditIndex(-1)}>
						<FontAwesomeIcon icon={faTimesCircle} />
					</Button>
				)}
			</Col>
			<Col></Col>
		</Row>
	);
};

const TagWithoutModal = () => {
	const {
		tagData,
		getAllTagsFromContext,
		createNewTagFromContext,
		updateTagFromContext,
	} = useContext(PropertyContext);

	const [editIndex, setEditIndex] = useState(-1);

	useEffect(() => {
		getAllTagsFromContext();
	}, []);

	return (
		<div className="px-5">
			<center>
				<h5 className="mb-4">Manage Tags</h5>
			</center>
			<TagLineInput
				{...{
					setEditIndex,
					getAllTagsFromContext,
					createNewTagFromContext,
					updateTagFromContext,
				}}
			/>
			<Row>
				<Col md={12}>
					{tagData?.length > 0 && (
						<Table>
							<thead className="thead-light">
								<tr>
									<th className="border-0">#ID</th>
									<th className="border-0 text-center">Tag</th>
									<th className="border-0 text-center">Action</th>
								</tr>
							</thead>
							<tbody>
								{tagData?.map((tag) =>
									tag?.id === editIndex ? (
										<tr>
											<td colSpan={3}>
												<TagLineInput
													{...{
														editData: tag,
														setEditIndex,
														getAllTagsFromContext,
														createNewTagFromContext,
														updateTagFromContext,
													}}
												/>
												{/* <Button size="xs" variant="danger">
													<FontAwesomeIcon icon={faStop} />
												</Button> */}
											</td>
										</tr>
									) : (
										<tr>
											<td className="border-0">{tag?.id}</td>
											<td className="border-0 text-center">
												{tag?.name}
											</td>
											<td className="border-0 text-center">
												<Button
													size="sm"
													variant="dark"
													onClick={() => setEditIndex(tag?.id)}
												>
													<FontAwesomeIcon icon={faEdit} />
												</Button>
											</td>
										</tr>
									)
								)}
							</tbody>
						</Table>
					)}
					{tagData?.length === 0 && (
						<center>
							<h6>No data</h6>
						</center>
					)}
				</Col>
			</Row>
		</div>
	);
};

const PropertyTag = ({ showTagModal, setShowTagModal }) => {
	return showTagModal ? (
		<Modal
			centered
			size="lg"
			className="modal-tertiary"
			show={showTagModal}
			onHide={() => setShowTagModal(!showTagModal)}
		>
			<Modal.Header>
				<Button
					variant="close"
					className="btn-close-dark text-dark"
					aria-label="Close"
					onClick={() => setShowTagModal(!showTagModal)}
				/>
			</Modal.Header>
			<Modal.Body className=" py-3">
				<TagWithoutModal />
			</Modal.Body>
		</Modal>
	) : (
		<TagWithoutModal />
	);
};

export default PropertyTag;
